// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"88":"be2026f0","141":"22dfdcfd","641":"8a7b0ec3","666":"6c1d03d4","729":"2cf637e3"}[chunkId] + ".js";
};